import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
  const location = useLocation();
  
  // Génération automatique des breadcrumbs si non fournis
  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: 'Accueil', path: '/' }];
    
    const pathLabels: Record<string, string> = {
      'tutors': 'Tuteur-trices',
      'profile': 'Mon profil',
      'create-profile': 'Créer mon profil',
      'edit': 'Modifier',
      'availability': 'Disponibilités',
      'subjects': 'Matières',
      'security': 'Sécurité',
      'requests': 'Demandes',
      'login': 'Connexion',
      'signup': 'Inscription',
      'aide': 'Aide',
      'faq': 'FAQ',
      'contact': 'Contact',
      'conditions': 'Conditions',
      'confidentialite': 'Confidentialité'
    };
    
    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = pathLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      const isLast = index === pathSegments.length - 1;
      
      breadcrumbs.push({
        label,
        path: isLast ? undefined : currentPath
      });
    });
    
    return breadcrumbs;
  };
  
  const breadcrumbItems = items || generateBreadcrumbs();
  
  if (breadcrumbItems.length <= 1) return null;
  
  return (
    <nav 
      aria-label="Breadcrumb" 
      className={`flex items-center space-x-2 text-sm text-gray-600 mb-4 ${className}`}
    >
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <i className="fas fa-chevron-right text-xs text-gray-400"></i>
          )}
          {item.path ? (
            <Link 
              to={item.path}
              className="hover:text-blue-600 transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-900 font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};
